<div>
  <form id="verifyForm" #verifyForm="ngForm" (ngSubmit)="onSubmit()" class="grid grid-cols-1 grid-rows-4">
    <div class="text-3xl sm:font-rhetorik-sans sm:text-40px">
      Verify Information
    </div>

      <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
        <mat-label>First Name</mat-label>
        <input matInput type="text" name="FirstName" id="FirstName" required [(ngModel)]="model.FirstName"
          #FirstName="ngModel">
        <mat-error>
          Please fill out this field
        </mat-error>
      </mat-form-field>

      <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
        <mat-label>Last Name</mat-label>
        <input matInput type="text" name="LastName" id="LastName" required [(ngModel)]="model.LastName"
          #LastName="ngModel">
        <mat-error>
          Please fill out this field
        </mat-error>
      </mat-form-field>

      <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
        <mat-label>Phone Number</mat-label>
          <mat-input-tel name="PhoneNumber" id="PhoneNumber" required
            [(ngModel)]="phoneNumber" #PhoneNumber="ngModel"
            ></mat-input-tel>
        <mat-error>
          Please fill out this field. Format: (123) 456-7889
        </mat-error>
      </mat-form-field>

      <div class="flex justify-center">
        <div class="w-full sm:w-1/3">
          <div class="grid col-gap-1">
            <button type="submit" mat-flat-button color="accent" [disabled]="!verifyForm.form.valid || proccessing">SUBMIT</button>
        </div>
      </div>



    </div>
  </form>
</div>
